import { useLanguage } from '../context/LanguageContext';
import { Quote, Star } from 'lucide-react';

export const TestimonialsSection = () => {
  const { t } = useLanguage();
  const testimonials = t('testimonials.items');

  return (
    <section id="testimonials" className="section-padding bg-[#f8fafc]" data-testid="testimonials-section">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 
            className="font-serif text-4xl md:text-5xl font-bold text-[#004d40] mb-4"
            data-testid="testimonials-title"
          >
            {t('testimonials.title')}
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            {t('testimonials.subtitle')}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {Array.isArray(testimonials) && testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="testimonial-card bg-white rounded-2xl p-8 shadow-sm card-hover"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote Icon */}
              <Quote className="w-10 h-10 text-[#4caf50]/30 mb-4" />

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#ffd700] text-[#ffd700]" />
                ))}
              </div>

              {/* Text */}
              <p className="text-slate-700 leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#004d40] to-[#00695c] flex items-center justify-center text-white font-bold text-lg">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <h4 className="font-bold text-[#004d40]">{testimonial.name}</h4>
                  <p className="text-slate-500 text-sm">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
